import { ServiceHandler } from '../../../../../utils';
import {
  GetCoveragePayloadSchemasResponse,
  GetFormsByCoveragesPayload,
  GetFormsByCoveragesResponse,
  GetTemplatePreviewUrlResponse,
} from './types';
import type {
  GetRaterXPresetsResponse,
  RaterXPreset,
  DefaultRaterXPresetsPayload,
  RecalculateRaterXPayload,
} from './types/rater-x-preset';

export const getRaterXPresets = ServiceHandler<
  DefaultRaterXPresetsPayload,
  GetRaterXPresetsResponse
>({
  url: '/api/quote/v1/:productType/presets',
  method: 'POST',
});

export const getRaterXDefaultPreset = ServiceHandler<
  DefaultRaterXPresetsPayload,
  RaterXPreset
>({
  url: '/api/quote/v1/:productKey/calculate',
  method: 'POST',
});

// Informational primary-reference rating for the excess UW view. Rates without
// treaty selection or carrier declination/referral gating, so a revenue/limit
// band the primary has no treaty for still returns a premium instead of
// declining. Never writes back to a quote. Same payload/response shape as
// `getRaterXDefaultPreset` but hits the dedicated reference-rate endpoint.
export const getRaterXReferenceRate = ServiceHandler<
  DefaultRaterXPresetsPayload,
  RaterXPreset
>({
  url: '/api/quote/v1/:productKey/reference-rate',
  method: 'POST',
});

export const recalculateRaterX = (
  quoteId: string | undefined,
  submissionId?: string | undefined
) => {
  let path = '/api/quote/v1/:productKey/calculate';

  if (submissionId) {
    path = `/api/quote/v1/:productKey/submission/${submissionId}/calculate`;
  }

  if (quoteId) {
    path = `/api/quote/v1/:productKey/calculate/${quoteId}`;
  }

  return ServiceHandler<RecalculateRaterXPayload, RaterXPreset>({
    url: path,
    method: 'POST',
  });
};

export const getFormsByCoverages = ServiceHandler<
  GetFormsByCoveragesPayload,
  GetFormsByCoveragesResponse
>({
  url: '/api/quote/v1/coverage-forms/by-coverage-and-state',
  method: 'POST',
});

export const getTemplatePreviewUrl = ServiceHandler<
  unknown,
  GetTemplatePreviewUrlResponse
>({
  url: '/api/quote/v1/coverage-forms/templates/:pdfCatalogId/preview-url',
  method: 'GET',
});

export const getCoveragePayloadSchemas = ServiceHandler<
  unknown,
  GetCoveragePayloadSchemasResponse
>({
  url: '/api/quote/v1/coverage-schemas/:productKey/:productVersion',
  method: 'GET',
});
